export default __webpack_public_path__ + "static/media/image25.75697885.svg";